export type SortOption =
  | "published"
  | "mileage_desc"
  | "mileage_asc"
  | "price_desc"
  | "price_asc"
  | "year_desc"
  | "year_asc";

export type SortOptionItem = {
  value: SortOption;
  label: string;
};

export const sortOptions: SortOptionItem[] = [
  { value: "published", label: "Publisert" },
  { value: "mileage_desc", label: "Km høy-lav" },
  { value: "mileage_asc", label: "Km lav-høy" },
  { value: "price_desc", label: "Pris høy-lav" },
  { value: "price_asc", label: "Pris lav-høy" },
  { value: "year_desc", label: "År høy-lav" },
  { value: "year_asc", label: "År lav-høy" },
];

export const getSortQueryParam = (sortOption: SortOption): string => {
  switch (sortOption) {
    case "published":
      return "";
    case "mileage_desc":
      return "&SortBy=Mileage&SortDirection=Desc";
    case "mileage_asc":
      return "&SortBy=Mileage&SortDirection=Asc";
    case "price_desc":
      return "&SortBy=Price&SortDirection=Desc";
    case "price_asc":
      return "&SortBy=Price&SortDirection=Asc";
    case "year_desc":
      return "&SortBy=ModelYear&SortDirection=Desc";
    case "year_asc":
      return "&SortBy=ModelYear&SortDirection=Asc";
    default:
      return "";
  }
};
